module.exports = __webpack_public_path__ + "img/pl.8901bcda.jpg";